import React from 'react';
import PropTypes from 'prop-types';
import {
    Row,
    Button,
    Col,
    ControlLabel,
    Form,
    FormControl,
    FormGroup,
    Checkbox,
} from 'react-bootstrap';
import Datetime from 'react-datetime';

const ManifestSearch = ({
    search,
    isFetching,
    handleChange,
    handleDateChange,
    handleSubmit,
    handleReset,
    prepareDataFormForEPSReport,
    showEpsDownload,
}) => (
    <Form horizontal onSubmit={handleSubmit}>
        <Row>
            <Col sm={3} className="no-gutter">
                <FormGroup controlId="routeCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        Route code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="routeCode"
                            value={search.routeCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="runDate">
                    <Col componentClass={ControlLabel} sm={5}>
                        Run date
                    </Col>
                    <Col sm={6}>
                        <Datetime
                            name="runDate"
                            value={search.runDate}
                            onChange={handleDateChange('runDate')}
                            dateFormat="DD-MM-YYYY"
                            timeFormat={false}
                            inputProps={{ maxLength: 255, placeholder: '...' }}
                            closeOnSelect
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="runSequence">
                    <Col componentClass={ControlLabel} sm={5}>
                        Run sequence
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="runSequence"
                            value={search.runSequence}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="manifestNumber">
                    <Col componentClass={ControlLabel} sm={5}>
                        Manifest number
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="manifestNumber"
                            value={search.manifestNumber}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
            </Col>
            <Col sm={3} className="no-gutter">
                <FormGroup controlId="emcCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        EMC code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="emcCode"
                            value={search.emcCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="emcPlantCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        EMC plant code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="emcPlantCode"
                            value={search.emcPlantCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="emcDockCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        EMC dock code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="emcDockCode"
                            value={search.emcDockCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="kanbanNumber">
                    <Col componentClass={ControlLabel} sm={5}>
                        Kanban number
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="kanbanNumber"
                            value={search.kanbanNumber}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
            </Col>
            <Col sm={3} className="no-gutter">
                <FormGroup controlId="supplierCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        Supplier code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="supplierCode"
                            value={search.supplierCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="supplierPlantCode">
                    <Col componentClass={ControlLabel} sm={5}>
                        Supplier plant code
                    </Col>
                    <Col sm={6}>
                        <FormControl
                            type="text"
                            maxLength="1000"
                            name="supplierPlantCode"
                            value={search.supplierPlantCode}
                            placeholder="..."
                            onChange={handleChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="pLaneExit">
                    <Col componentClass={ControlLabel} sm={5}>
                        P-lane exit
                    </Col>
                    <Col sm={6}>
                        <Datetime
                            name="pLaneExit"
                            value={search.pLaneExit}
                            onChange={handleDateChange('pLaneExit')}
                            dateFormat="DD-MM-YYYY"
                            timeFormat={'HH:mm'}
                            inputProps={{ maxLength: 255, placeholder: '...' }}
                            closeOnSelect
                        />
                    </Col>
                </FormGroup>
                <FormGroup controlId="includeGhosts">
                    <Col
                        componentClass={ControlLabel}
                        sm={5}
                        title="Ghosts manifests are manifests without kanbans"
                    >
                        Show ghost manifests?
                    </Col>
                    <Col sm={6} style={{ marginTop: -7, marginBottom: 7 }}>
                        <Checkbox
                            name="includeGhosts"
                            checked={search.includeGhosts}
                            onChange={handleChange}
                            inline
                        />
                    </Col>
                </FormGroup>
            </Col>
            <Col sm={3} className="no-gutter">
                <FormGroup>
                    <Col sm={6}>
                        <Button
                            type="submit"
                            style={{ width: '100%' }}
                            bsStyle="primary"
                            disabled={isFetching}
                        >
                            {isFetching ? 'Searching...' : 'Search'}
                        </Button>
                    </Col>
                </FormGroup>
                <FormGroup>
                    <Col sm={6}>
                        <Button
                            type="reset"
                            style={{ width: '100%' }}
                            disabled={isFetching}
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                    </Col>
                </FormGroup>
                {showEpsDownload && <FormGroup>
                    <Col sm={6}>
                        <Button
                            style={{ width: '100%' }}
                            bsStyle="primary"
                            href={`api/download-brexit-special-manifest-pdf?${prepareDataFormForEPSReport(search)}`}
                        >
                            Generate EPS Report
                        </Button>
                    </Col>
                </FormGroup>}
            </Col>
        </Row>
    </Form>
);

ManifestSearch.propTypes = {
    search: PropTypes.object,
    isFetching: PropTypes.bool,
    handleChange: PropTypes.func,
    handleDateChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    handleReset: PropTypes.func,
    showEpsDownload: PropTypes.bool,
};
ManifestSearch.defaultProps = {
    showEmaModal: false,
    showEpsDownload: false,
};

export default ManifestSearch;
